import React, {Component} from 'react';
import '../trace.css';
import './Home.css'
import NavBar from "../elements/NavBar";
import github_logo from '../media/logo-github.svg';

class Home extends Component {
  render() {
    return <div id="page_home">
      <header className="header full_page">
        <NavBar alwaysPinned={false} />
      </header>
      <div className="">
        <div className="contentTemp">
          <p>The Team Research Analytics in Computational Environments (TRACE) research group was founded in 2017 at Clemson University's School of Computing by Dr. Nathan J. McNeese. The group conducts research on Team Decision Making, Cognition, Human Computer Interaction, and Computer Supported Collaborative Work.
          </p>
          <a href="https://github.com/ClemsonTRACE" className="logo logoGroup">
            <img src={github_logo} className="github_logo" alt="Clemson TRACE's Github"/>
          </a>
        </div>

      </div>
    </div>;
  }
}

export default Home;
